import { useSettings } from "@/lib/settings";

const SIZES = {
  lg: {
    label: "text-xs sm:text-sm",
    value: "text-5xl sm:text-6xl",
    caption: "text-[0.6rem] sm:text-xs",
  },
  md: {
    label: "text-[0.65rem] sm:text-xs",
    value: "text-4xl sm:text-5xl",
    caption: "text-[0.55rem] sm:text-[0.65rem]",
  },
  sm: {
    label: "text-[0.6rem]",
    value: "text-2xl sm:text-3xl",
    caption: "text-[0.55rem]",
  },
};

export function PremiumPriceDisplay({
  size = "md",
  caption,
  align = "center",
  tone = "dark",
  testId = "premium-price",
}) {
  const { settings } = useSettings();
  const s = SIZES[size] || SIZES.md;
  const captionColor = tone === "light" ? "text-vinho/60" : "text-creme/60";

  return (
    <div
      data-testid={testId}
      className={`relative inline-flex flex-col gap-1.5 ${
        align === "left" ? "items-start text-left" : "items-center text-center"
      }`}
    >
      <span className={`${s.label} font-semibold uppercase tracking-[0.35em] text-[#A47B2C]`}>
        Por apenas
      </span>
      <span className="relative inline-block">
        <span className="price-glow" aria-hidden="true" />
        <span className={`price-shine relative whitespace-nowrap font-serif font-bold leading-none ${s.value}`}>
          {settings.price_display}
        </span>
      </span>
      {caption && (
        <span className={`${s.caption} mt-0.5 uppercase tracking-[0.3em] ${captionColor}`}>
          {caption}
        </span>
      )}
    </div>
  );
}
